<template>
    <accordion-card :header="header" :header-link="headerLink">
        <div v-if="searchResult['highlight']" class="search-result-snippet-container mb-3">
            <div v-for="(highlightResults, fieldName) in searchResult['highlight']" :key="fieldName">
                <div v-for="(result, index) in highlightResults" :key="index" class="search-result-snippet">
                    {{ translate('frontend.search.snippets.found_in') }} {{ translate('frontend.search.snippets.' + searchResult['index_name'] + '.' + fieldName) }}: <span v-html="result"></span>
                </div>
            </div>
        </div>
    </accordion-card>
</template>

<script>
    export default {
        props: {
            query: { type: String, required: true },
            searchResult: { type: Object, required: true },
            resultsPerCard: { type: Number, required: false, default: 5 },
            locale: { type: String, required: true }
        },

        data() {
            return {
		        collapsed: true
            }
        },

        computed: {
            header() {
                const indexName = this.searchResult['index_name'];
                const title = this.translate('frontend.search.results.index_name.' + indexName);

                let header = '<div class="search-result-type"><div class="index-name">' + title +'</div></div><div>';
                
                if (this.searchResult['index_name'] === 'authors') {
                    header += this.searchResult['document']['content']['name_' + this.locale];
                } else if (this.searchResult['index_name'] === 'works') {
                    header += this.searchResult['document']['content']['title_' + this.locale];
                } else if (this.searchResult['index_name'] === 'versions') {
                    let versionType = this.translate('frontend.version.' + this.searchResult['document']['content']['version_type_facet']);
                    let versionLanguages = this.searchResult['document']['content']['version_language_' + this.locale + '_facet'];
                    let versionDetails = [versionType, versionLanguages ? versionLanguages.join(', ') : ''].filter(Boolean).join(', ');
                    header += this.searchResult['document']['content']['title'] + ' (' + versionDetails + ')';
                } else if (this.searchResult['index_name'] === 'topics') {
                    header += this.searchResult['document']['content']['name_' + this.locale];
                }
                header += '</div>';
                return header;
            },

            headerLink() {
                return '/' + this.locale + '/' + this.searchResult['index_name'] + '/' + this.searchResult['document']['id'];
            }
        }
    }
</script>

<style lang="scss" scoped>
    h3 {
        margin-bottom: 0 !important;
        padding-bottom: 0;
        border-bottom: none;
    }

    .card-result {
        background-color: darken($color: #fff, $amount: 1);
        border-bottom:1px solid #dac9be;
        padding: 12px 8px;

        &:nth-child(odd) {
            background-color: darken($color: #fff, $amount: 3);
        }
    }

    .search-result-snippet {
        &::v-deep em {
            padding: 2px 4px;
            background-color: #da831e4d;
            border-radius: 10%;
        }
    }

    .is-collapsed {
	    display: none;
    }

    .searchmore {
        margin-top: 15px;
    }
</style>